import { createContext } from 'react';
import type { GridRowId } from '@mui/x-data-grid-pro';

export interface ExpandedCell {
  rowId: GridRowId;
  field: string;
  height: number | null;
}

interface ExpandableCellContextValue {
  expanded: ExpandedCell | null;
  // Omitted by a grid that has not wired dynamic row height, which leaves its cells tooltip-only.
  reportTruncation?: (rowId: GridRowId, field: string, truncated: boolean) => void;
  reportExpandedHeight?: (height: number) => void;
  clearExpanded?: () => void;
}

export const ExpandableCellContext = createContext<ExpandableCellContextValue>({ expanded: null });

export const ExpandableCellProvider = ExpandableCellContext.Provider;

export const cellKey = (rowId: GridRowId, field: string): string => `${rowId}|${field}`;

export const isSameCell = (cell: ExpandedCell | null | undefined, rowId: GridRowId, field: string): boolean =>
  !!cell && cell.rowId === rowId && cell.field === field;
